import { Button, Group, Text } from "@mantine/core";
import { ConfirmAndExecutePanel, EntityClientAction } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { SolicitudesRuteoInfo } from "./SolicitudesRuteoInfo";

export const ACTRechazarSolicitud: EntityClientAction = {
    name: 'ACTRechazarSolicitud',
    label: 'Rechazar Solicitud',
    title: <Text fw={700}>Rechazar solicitud de ruta</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    views: ['sorui_brwStandard'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        // cast entity
        const solicitud = entity as SolicitudesRuteoInfo;

        const procParms = {
            c_solicitudruteo_id: selectedKeys?.[0]?.['c_solicitudruteo_id'] ?? ''
        };

        let errores = '';

        if (!procParms.c_solicitudruteo_id) {
            errores = 'Los registros seleccionados son inválidos';
        }

        if (errores) {
            await modal.open({
                modalProps: {
                    title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">ERROR</Text></Group>,
                },
                focusOnClosed: element,
                content:
                    <>
                        <Text size="sm" mb="xs">
                            {errores}
                        </Text>
                        <Group mt="xs" position="right">
                            <Button onClick={async () => await modal.close()}>Cerrar</Button>
                        </Group>
                    </>
            });

        }
        else {
            const abort_controller = new AbortController();

            await modal.open({
                modalProps: {
                    title: <Text fw="700">Rechazar solicitud de ruteo</Text>
                },
                focusOnClosed: element,
                content: <ConfirmAndExecutePanel
                    content={<Text size="sm" mb="xs">Va a rechazar la solicitud de ruteo. ¿Está seguro?</Text>}
                    operation="proc"
                    onCancel={async () => { await abort_controller.abort(); await modal.close(); }}
                    onOK={
                        async () => {
                            const result = await solicitud.API.executeProcess(solicitud.def.procs.sorui_Rechazar, procParms, abort_controller.signal);
                            const success = result.Failed === false;
                            if (onClose) await onClose(success);
                            if (success) await modal.close();
                            return result;
                        }
                    }
                />

            });
        }

        return false;
    }
}